<template>
  <v-dialog
    v-model="modalShowing"
    content-class="my-dialog"
    :width="modal.width"
    :max-width="modal.maxWidth"
  >
    <template v-slot:activator="{ on }">
      <slot name="button" :modalShowing="modalShowing" />
    </template>
    <v-card id="rentThisForm">
      <v-icon class="modal__close" @click.stop="setModalRentShowing(false)">
        close
      </v-icon>
      <h2>Make Offer</h2>
      Start a discussion with your agent {{ agent.name }} about renting: {{ home['Address'] }}
      <br>
      <v-card-actions>
        <button
          v-ripple="{ class: 'grey--text', center: true}"
          class="buttonSend"
          @click="sendOffer"
        >
          Send
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {

  props: {
    agent: {
      type: Object,
      required: true
    },
    home: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modalShowing: false,
      subject: 'Rental Inquiry'
    }
  },

  computed: {
    ...mapState('style', ['modal']),
    ...mapState('client', ['clientData'])
  },

  watch: {
    modalRentShowing(newVal, oldVal) {
      this.$emit('modal-changed', newVal)
    }
  },
  methods: {
    sendOffer() {
      this.$emit('submit-modal', {
        to: [this.agent._id],
        address: `${this.home['Address']} ${this.home['City']} ${this.home['PostalCode']}`,
        agent: this.agent.name,
        propertyId: this.home._id,
        clientPhone: this.clientData.phone
      })
      this.setModalRentShowing(false)
    },
    setModalRentShowing(val) {
      this.modalShowing = val
    }
  }
}
</script>

<style lang="sass" scoped>
*:focus
  outline: none

#rentThisForm
  @extend %modal

.modal__close
  @extend %modal__button-close, %disable-selection

.rent-this__icon
  @extend %modal__icon

.v-card__rent-this
  width: fit-content
  margin: 1rem auto
  margin-top: 3rem

.area-label
  display: block
  text-transform: capitalize
  margin-bottom: 1.5rem !important

.buttonSend
  @extend %modal__button
  margin-top: 1rem
</style>
